import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { LanguageService } from './language.service';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FacebookServiceService } from './facebook-service.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var google: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  uluru: Object = { lat: -25.363, lng: 131.044 };
  map: Object;
  marker: Object;
  zoom: number;
  @ViewChild('map', {static: false}) mapRef: ElementRef;
  menu:any = false;

  title = 'hitech-website-v56';
  loaded:any = false;
  currentPage:any = "";
  contactForm:any = { email:"", name:"", title:"", message:"" };
  subscribe_email:any = "";

  sentMessage:any = false;
  sentMessageType:any = 0;

  gdpr:any;

  constructor(public langServ:LanguageService, private router: Router, private http:HttpClient, private fbService:FacebookServiceService, sanitizer:DomSanitizer) { 
    this.GetGDPR();
  }

  onActivate(event) {
      // document.body.scrollTop = 0;
      // document.querySelector('body').scrollTo(0,0);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      console.log(evt);
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      this.currentPage = evt.url;
      if(evt.url != '/services' && evt.url.indexOf('/project') == -1) {
        setTimeout(() => {
          this.map = new google.maps.Map(this.mapRef.nativeElement, {
            center: {lat: 42.138828, lng:24.788299},
            styles:[{"featureType":"all","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#838383"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#c4c4c4"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#aaaaaa"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#696969"},{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"lightness":21},{"visibility":"on"},{"color":"#f33737"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"weight":"2"},{"visibility":"on"},{"color":"#494949"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"poi.medical","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#333333"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#232323"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#232323"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#434343"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#212121"},{"weight":"2"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#999999"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
            zoom: 16,
            disableDefaultUI: true
          });
          var image = {
            url: 'assets/ic/hitech-pin.png'
          };
          var marker = new google.maps.Marker({
            position: {lat: 42.138828, lng:24.788299},
            map: this.map,
            icon: image
          });
        }, 2000);
      }
    });

    setTimeout(() => {
      // this.map = new google.maps.Map(this.mapRef.nativeElement, {
      //   center: {lat: 42.138828, lng:24.788299},
      //   styles:[{"featureType":"all","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#838383"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#c4c4c4"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#aaaaaa"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#696969"},{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"lightness":21},{"visibility":"on"},{"color":"#f33737"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"weight":"2"},{"visibility":"on"},{"color":"#494949"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"poi.medical","elementType":"geometry.fill","stylers":[{"color":"#696969"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#333333"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#232323"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#232323"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#434343"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#212121"},{"weight":"2"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#999999"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
      //   zoom: 16,
      //   disableDefaultUI: true
      // });
      // var image = {
      //   url: 'assets/ic/hitech-pin.png'
      // };
      // var marker = new google.maps.Marker({
      //   position: {lat: 42.138828, lng:24.788299},
      //   map: this.map,
      //   icon: image
      // });
    }, 2000);
    // this.loaded = false;

    setTimeout(()=>{
      this.loaded = true;
    }, 1000);
  }

  GetGDPR() {
    this.http.get("https://axion.solutions/api/service.php?action=get_gdpr").subscribe(
      response => { this.gdpr = response['gdpr'];},
      error => {  });
  }

  SaveGDPR() {
    this.http.get("https://axion.solutions/api/service.php?action=save_gdpr").subscribe(
      response => { this.gdpr = "1";},
      error => {  });
  }

  sendMail() {
    this.http.get("https://axion.solutions/api/service.php?action=send_mail&name=" + this.contactForm.name + "&title=" + this.contactForm.title + "&message=" + this.contactForm.message + "&email=" + this.contactForm.email).subscribe(
    response => { 
      if(this.returnIsValidEmail(this.contactForm.email) && this.contactForm.name.length > 0 && this.contactForm.title.length > 0 && this.contactForm.message.length > 0){
        this.contactForm.name = "";
        this.contactForm.title = "";
        this.contactForm.message = "";
        this.contactForm.email = "";
        this.sentMessage = true;
        this.sentMessageType = 1;
        setTimeout(() => {
          this.sentMessage = false;
        }, 5000);
      }

    },
    error => {  });
  }

  subscribeMail() {
    this.http.get("https://axion.solutions/api/service.php?action=subscribe&email=" + this.subscribe_email).subscribe(
    response => { 
      this.subscribe_email = "";
      this.sentMessage = true;
      this.sentMessageType = 2;
      setTimeout(() => {
        this.sentMessage = false;
      }, 5000);
    },
    error => {  });
  }


  linkTo(link) { window.location.href = link;  }

  switchMenu() { this.menu = !this.menu; }
  closeMenu() { this.menu = false; }

  returnLoaded() { return this.loaded; }
  returnIsFullPage() {
    if(this.currentPage == '/service/video' || this.currentPage == '/service/software' || this.currentPage == '/service/hardware' || this.currentPage == '/service/design' || this.currentPage == '/service/cloud' || this.currentPage == '/service/network'){
      return true;
    }
    if(this.currentPage == '/projects/all' || this.currentPage == '/projects/video' || this.currentPage == '/projects/software' || this.currentPage == '/projects/hardware' || this.currentPage == '/projects/design' || this.currentPage == '/projects/cloud' || this.currentPage == '/projects/network'){
      return true;
    }
    return false;
  }
  returnIsValidEmail(mail) 
  {
   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
    {
      return (true)
    }
      return (false)
  }
}
